// extracted by mini-css-extract-plugin
export default {"mediumWidth":"input-suggestions-dropdown-module__mediumWidth--sLSSy","popupMobilePanel":"input-suggestions-dropdown-module__popupMobilePanel--MmJrU"};